import {isBlank, isNotEmpty} from "./CommonUtil.ts";
import Noty from "noty";
import "noty/lib/noty.css";
import "noty/lib/themes/semanticui.css";
import "../../style/common/noty/message_noty.scss";

const _theme = "semanticui";

/**
 * 確認ダイアログ表示
 */
export function popConfirm(
    message: string,
    callAccept = () => {},
    callDecline = () => {}) {
    confirmMessage({
        message: message,
        callAccept: callAccept,
        callDecline: callDecline,
    });
}

/**
 * メッセージ表示
 */
export function popInfo(message: string, callClose = () => {}) {
    showMessages({
        message: message, type: "info",
        callClose: callClose,
    })
}

/**
 * エラー表示
 */
export function popErrors(message: string, callClose = () => {}) {
    showMessages({message: message, type: "error", callClose: callClose})
}


/**
 * メッセージ表示（改行をリスト表示）
 */
// function showMessages(
//     {
//         message = "",
//         layout = "center",
//         modal = true,
//         type = "info",
//         callClose = () => {}
//     }) {
//     let error_message = "";
//     if(/\r\n|\r|\n/.test(message)) {
//         error_message =
//             "<ul>";
//         const textArray = message.split(/\r\n|\r|\n/);
//         textArray.forEach(function(value: string) {
//             if (isNotEmpty(value)) {
//                 error_message = error_message + "<li>" + value + "</li>";
//             }
//         });
//         error_message = error_message + "</ul>";
//     } else {
//         error_message = message;
//     }
//     let n = new Noty({
//         text: error_message,
//         theme: _theme,
//         modal: modal,
//         // @ts-ignore
//         type: type,
//         // @ts-ignore
//         layout: layout,
//         closeWith: [],
//         buttons: [
//             Noty.button(
//                 "閉じる",
//                 "btn btn-light btn-sm",
//                 function () {
//                     callClose();
//                     n.close();
//                 },
//                 { id: "button1", "data-status": "ok" }
//             ),
//         ],
//     });
//     n.show();
// }

function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

function showMessages({
                          message = "",
                          layout = "center",
                          modal = true,
                          type = "info",
                          callClose = () => {}
                      }) {
    const lines = message
        .split(/\r\n|\r|\n/)
        .filter(v => isNotEmpty(v) && v.trim().length > 0);
    let formatted_message: string;
    if (lines.length > 1) {
        formatted_message = `<ul>${lines.map(v => `<li>${escapeHtml(v)}</li>`).join("")}</ul>`;
    } else {
        formatted_message = escapeHtml(message);
    }

    const n = new Noty({
        text: formatted_message,
        theme: _theme,
        modal: modal,
        // @ts-ignore
        type: type,
        // @ts-ignore
        layout: layout,
        closeWith: [],
        buttons: [
            Noty.button(
                "閉じる",
                "btn btn-secondary btn-sm",
                function () {
                    callClose();
                    n.close();
                },
                { id: "button1", "data-status": "ok" }
            ),
        ],
    });
    n.show();
}


/**
 * 確認ダイアログ表示
 */
function confirmMessage(
    {
        message = "",
        layout = "center",
        modal = true,
        type = "alert",
        callAccept = () => {},
        callDecline = () => {},
    }) {
    const formattedMsg = escapeHtml(message).replace(/\r\n|\r|\n/g, "<br>");
    let n = new Noty({
        text: formattedMsg,
        theme: _theme,
        modal: modal,
        // @ts-ignore
        type: type,
        // @ts-ignore
        layout: layout,
        className: "confirm-message-noty",
        closeWith: [],
        buttons: [
            Noty.button(
                "いいえ",
                "btn btn-secondary btn-sm",
                function () {
                    callDecline();
                    n.close();
                },
                { id: "btn-no", "data-status": "no" }
            ),
            Noty.button(
                "はい",
                "btn btn-primary btn-sm",
                function () {
                    callAccept();
                    n.close();
                },
                { id: "btn-yes", "data-status": "yes" }
            ),
        ],
    });
    n.show();
}

export function concatMessage(newMsg: string, existingMsg: string) {
    if (isBlank(newMsg)) return existingMsg;
    if (isBlank(existingMsg)) return newMsg;
    return existingMsg + "\n" + newMsg;
}
